import Footer from "./components/common/Footer";
import Header from "./components/common/Header";
import ScrollToTop from "./components/ScrollToTop";
import AppRoutes from "./routes/AppRoutes";

const App = () => {
  return (
    <>
      <ScrollToTop />
      <Header />
      <AppRoutes />
      <Footer />
    </>
  );
};

export default App;
